export default __webpack_public_path__ + "static/media/CUMPLIENDO.5ca4f9b7.jpg";